module.exports = __webpack_public_path__ + "static/media/myBookings.497b21b9.svg";